var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12.5006C2 6.97769 6.47769 2.5 12.0006 2.5C17.5211 2.50626 21.995 6.98019 22 12.5006C22 18.0223 17.5236 22.5 12.0006 22.5C6.47769 22.5 2 18.0223 2 12.5006ZM20.3339 12.5006C20.3339 7.89776 16.6035 4.16615 12.0006 4.16615C7.40026 4.17115 3.6724 7.90026 3.6674 12.5006C3.6674 17.1022 7.39776 20.8339 12.0006 20.8339C16.6035 20.8339 20.3339 17.1022 20.3339 12.5006ZM10.079 11.1024L11.6951 9.48636C12.102 9.07952 12.102 8.41983 11.6951 8.01424C11.2883 7.60741 10.6286 7.60741 10.223 8.01424L6.47261 11.7634C6.27733 11.9587 6.16718 12.224 6.16718 12.5007C6.16718 12.7761 6.27733 13.0415 6.47261 13.2368L10.223 16.9859C10.6286 17.3927 11.2883 17.3927 11.6951 16.9859C12.102 16.5803 12.102 15.9206 11.6951 15.5138L10.079 13.8977C10.0202 13.8376 10.0027 13.7487 10.0352 13.6711C10.0665 13.5935 10.1429 13.5422 10.2268 13.5422H16.7924C17.367 13.5422 17.8339 13.0753 17.8339 12.5007C17.8339 11.9249 17.367 11.4592 16.7924 11.4592H10.2268C10.1429 11.4592 10.0653 11.4079 10.034 11.3303C10.0014 11.2526 10.019 11.1625 10.079 11.1024Z",
    fill: "#D64309"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedBack);
export default __webpack_public_path__ + "static/media/RedBack.ea0cf7dbacbfa93addc682c31b183161.svg";
export { ForwardRef as ReactComponent };